import React from 'react';
import {
  Box,
  Switch,
  FormControlLabel,
  Tooltip,
} from '@mui/material';
import { useDashboardLive } from '../contexts/DashboardLiveContext';

const GoLiveToggle = () => {
  const { isLiveEnabled, isLoading, isSaving, setLiveEnabled } = useDashboardLive();

  const handleToggle = async (event) => {
    try {
      await setLiveEnabled(event.target.checked);
    } catch (err) {
      console.error('Failed to update live dashboard setting:', err);
    }
  };

  const activeColor = isLiveEnabled ? '#10b981' : '#40518A';

  return (
    <Tooltip title={isLiveEnabled ? 'Turn off live updates' : 'Turn on live updates'}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          textAlign: 'center',
          px: { xs: 1, sm: 1.5 },
          py: { xs: 0.5, sm: 0.75 },
          borderRadius: 2,
          background: '#ffffff',
          border: '1px solid #0000001F',
          boxShadow: '0 6px 18px rgba(0,0,0,0.12)',
          transition: 'all 0.3s ease',
          '&:hover': {
            bgcolor: '#f9fafb',
            boxShadow: '0 8px 24px rgba(0,0,0,0.16)',
          },
        }}
      >
        <FormControlLabel
          control={(
            <Switch
              checked={isLiveEnabled}
              onChange={handleToggle}
              disabled={isLoading || isSaving}
              size="small"
              sx={{
                '& .MuiSwitch-switchBase.Mui-checked': {
                  color: '#008000',
                  '&:hover': {
                    backgroundColor: 'rgba(16, 185, 129, 0.08)',
                  },
                },
                '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                  backgroundColor: '#008000',
                },
                '& .MuiSwitch-switchBase': {
                  color: '#40518A',
                  '&:hover': {
                    backgroundColor: 'rgba(64, 81, 138, 0.08)',
                  },
                },
                '& .MuiSwitch-track': {
                  backgroundColor: '#40518A',
                },
              }}
            />
          )}
          label={isLiveEnabled ? 'Live' : 'Go Live'}
          sx={{
            m: 0,
            color: activeColor,
            '& .MuiFormControlLabel-label': {
              fontWeight: 600,
              fontSize: { xs: '0.8rem', sm: '0.9rem' },
              minWidth: { xs: 52, sm: 58 },
              display: 'inline-block',
            },
          }}
        />
      </Box>
    </Tooltip>
  );
};

export default GoLiveToggle;
